import { colors } from '@material-ui/core';
import React from 'react'

export default function DeCardOrderProducts(props) {
    const data = props.data;
    const title = props.title;
    return (
        <div className="category-container">
            <div className="user-order-container">
                <h4 className="family-Courgette">{title}</h4>
                <table className="details" style={{ minWidth: "100%" }}>
                    <tbody>
                        <tr>
                            <td><b>Product:</b></td><td ><span>{data.product?.product_name}</span></td>
                        </tr>
                        <tr>
                            <td><b>Quantity:</b></td><td><span className='badge badge-dark'> x {data.quantity}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
